module.exports = __webpack_public_path__ + "app/principal/user/principal-user-detail-3LZ42k4F.html";